import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { useUserStore } from '@/stores/userstore'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)

// Directive click-outside
app.directive('click-outside', {

  mounted(el, binding) {
    el._clickOutside = (e) => {
      if (!el.contains(e.target)) binding.value() // Si l'element cliqué se retrouve à l'exterieur alors on déclenche l'action transmise par le param binding
    }
    document.addEventListener('click', el._clickOutside)
  },

  unmounted(el) {
    document.removeEventListener('click', el._clickOutside)
  }
})

// ✅ Now that Pinia is installed, we can use the store
router.beforeEach((to, from, next) => {
  const userStore = useUserStore()

  //Bypass checks if valid secureToken
  const secureToken = to.meta?.secureToken
  const urlToken    = to.query?.token
  if (secureToken && urlToken === secureToken) return next()

  // 1) Check if this route requires auth
  if (to.meta.requiresAuth && !userStore.isLoggedIn) {
    return next({
      path: '/Login',
      query: { redirect: to.fullPath }
    })
  }

  // 2) If a requiredGroup is specified, check membership
  if (to.meta.requiredGroup && !userStore.current_user_groups.includes(to.meta.requiredGroup)) {
    return next('/403')
  }

  // 3) Otherwise proceed
  next()
})

app.mount('#app')
